export default __webpack_public_path__ + "static/media/diamond-cut-1@3x.737ea339.jpg";